import React from 'react';
import { PoolItem } from 'components/Calculator';
import { IPaymentSetCalculations } from 'types';
import { IExportData } from './types';

interface IPoolReportProps {
  header: (data?: IExportData) => React.ReactNode;
  calculations?: IPaymentSetCalculations;
  businessDay?: string;
  isLoading?: boolean;
}

const PoolReport = ({ header, calculations, businessDay, isLoading }: IPoolReportProps) => {
  if (isLoading || !calculations?.results?.length) return <></>;

  return (
    <>
      {header()}
      {calculations.results.map((result, idx) => (
        <PoolItem key={`pool_item_${idx}`} calculatorResult={result} businessDay={businessDay} />
      ))}
    </>
  );
};

export default PoolReport;
